export default "__VITE_ASSET__CvkLQJsF__"